import Costs from "./Costs";
import InvoicingSettings from "./InvoicingSettings";
import Confirm from "./Confirm";

export default {
  COSTS: Costs,
  INVOICING: InvoicingSettings,
  CONFIRM: Confirm,
};
